
<form>
    <div class="form-group row">
        <div class="col-12 text-center">
            <label class="col-form-label">Password</label>
        </div> 
    </div>
    <div class="form-group row">
        <!-- <label for="reasonDesc1Check" class="col-sm-3 col-form-label text-right">Password</label> -->
        <div class="col-sm-12">
            <div class="input-group">
                <!-- <input type="password" id="password" placeholder="Enter the password" [formControl]="resetCheck"> -->
                <input appBlockQuotes id="settingsPwd" name="settingsPwd" type="{{ hidePass ? 'password' : 'text' }}" class="form-control  hide-border-right"
                [formControl]="resetCheck" placeholder="Enter Password" #passwordInput>
            <div class="input-group-append">
              <span class="input-group-text passwordiconcontainer hide-border-left backgroundwhite"
                (click)="hidePass = !hidePass">
                <mat-icon>{{hidePass ? 'visibility_off' : 'visibility'}}</mat-icon>
              </span>
            </div>
            </div>
            <mat-error *ngIf="errorMessage !== null">{{errorMessage}}</mat-error>
        </div>

        <div class="col-sm-12" style="margin-top: 30px; display: flex; justify-content: center;">
            <div fxLayout="row" fxLayoutAlign="center">
                <button mat-button class="selectionButton cancelButton" [mat-dialog-close]="false">Cancel</button>
                <button mat-button class="selectionButton saveButton" style="margin-left: 8px;" (click)="OnSubmitClick(true)">{{submitBtnLabel}}</button>
            </div>
        </div>
    </div>
</form>